export const kitTotal = (arr) => {
  var counter = 0;

  for (let i = 0; i < arr.length; i++) {
    if (typeof arr[i].category === "undefined") {
      counter += parseFloat(arr[i].amount);
    } else {
      for (let j = 0; j < arr[i].category.length; j++) {
        counter += parseFloat(arr[i].category[j].amount);
      }
    }
  }

  return counter;
};

export const findTax = (arr, tax) => {
  let x = 0;

  for (let k = 0; k < arr.length; k++) {
    const items = arr[k].items;
    for (let i = 0; i < items.length; i++) {
      if (typeof items[i].category === "undefined") {
        if (items[i].tax) {
          x += parseFloat(items[i].amount) * (tax / 100);
        }
      } else {
        const categories = items[i].category;
        for (let j = 0; j < categories.length; j++) {
          if (categories[j].tax) {
            x += parseFloat(categories[j].amount) * (tax / 100);
          }
        }
      }
    }
  }
  return x;
};

export const findTotalTax = (arr, tax) => {
  let x = 0;
  for (let k = 0; k < arr.length; k++) {
    const items = arr[k].items;
    for (let i = 0; i < items.length; i++) {
      if (!items[i].fundsReceived) {
        if (typeof items[i].category === "undefined") {
          if (items[i].tax) {
            x += parseFloat(items[i].amount) * (1 + tax / 100);
          } else {
            x += parseFloat(items[i].amount);
          }
        } else {
          const categories = items[i].category;
          for (let j = 0; j < categories.length; j++) {
            if (categories[j].tax) {
              x += parseFloat(categories[j].amount) * (1 + tax / 100);
            } else {
              x += parseFloat(categories[j].amount);
            }
          }
        }
      }
    }
  }
  return x;
};

export const findFundsReceived = (arr) => {
  let receivedFunds = [];
  for (let i = 0; i < arr.length; i++) {
    const items = arr[i].items;
    for (let k = 0; k < items.length; k++) {
      if (items[k].fundsReceived) {
        receivedFunds.push(items[k].amount);
      }
    }
  }

  return receivedFunds.reduce((a, b) => a + b);
};
